<template>
  <div class="class_item" :class="option === 1 ? 'pro' : ''">
    <ul class="item_img">
      <li
        v-for="(item, index) in item.products"
        :key="index"
        :class="option == 1 ? 'pro_img' : ''"
        @click="
          goViewHandler({ path: '/product/detail', query: { pid: item.id } })
        "
      >
        <el-image :src="item.smallPhoto" fit="fit"></el-image>
      </li>
    </ul>

    <div class="item_titel" v-if="option === 1">{{ item.name }}</div>
    <div class="item_titel" v-else>
      {{ item.name }}({{ item.productCount }})
    </div>
    <div class="item_h2" v-if="option === 1">({{ item.productCount }})</div>
    <div class="item_btn" @click="goBtn(item.id, item.name)">更多的</div>
  </div>
</template>
<script>
import { useRouter, useRoute } from 'vue-router'
export default {
  name: 'item',
  props: {
    middleId: { type: Number },
    option: { type: Number },
    item: {
      type: Object,
      value: {}
    }
  },
  setup (props) {
    const router = useRouter()
    const routue = useRoute()
    const goBtn = (id, name) => {
      if (routue.path.startsWith('/product/proCenter')) {
        router.push({
          path: '/product/native',
          query: {
            middleClassId: props.middleId,
            name: name,
            smallClassId: id
          }
        })
      } else {
        router.push({
          path: '/product/proCenter',
          query: { bigClassId: id, name: name }
        })
      }
    }
    const goViewHandler = (obj) => {
      router.push(obj)
    }
    return {
      goViewHandler,
      goBtn
    }
  }
}
</script>
<style lang="scss" scoped>
.class_item {
  width: 380px;
  background: white;
  border-radius: 8px;
  padding: 12px 0 20px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 6px 25px 6px;
  transition: all 0.3s ease 0s;
  &:hover {
    transform: scale(1.01);
  }
  &.pro {
    width: 310px;
  }
  .item_btn {
    width: 96px;
    height: 36px;
    line-height: 36px;
    font-size: 16px;
    text-align: center;
    color: white;
    background: linear-gradient(90deg, #ff5e41 0%, #fc4353 100%);
    opacity: 1;
    border-radius: 4px;
    margin: 24px 0 0 0;
    cursor: pointer;
  }
  .item_titel {
    margin: 16px 0 0 0;
    color: #3e3a39;
    font-size: 18px;
  }
  .item_h2 {
    color: #cccccc;
    font-size: 16px;
    margin: 12px 0 0 0;
  }
  .item_img {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    li {
      width: 114px;
      height: 114px;
      overflow: hidden;
      margin: 0 0 7px 10px;
      cursor: pointer;
      &.pro_img {
        width: 90px;
        height: 90px;
        overflow: hidden;
        margin: 0 0px 7px 10px;
      }
    }
  }
}
</style>
